import createAxios from "../../utils/createAxios";
import { category_set, page_refresh } from "../actions/pageAction";
import axios from "axios";

//set current category on product page
export const categorySet = (data) => async (dispatch) => {
  dispatch(category_set(data));
};

//page refresh control
export const pageRefresh = () => async (dispatch) => {
  dispatch(page_refresh());
};

export const contactSubmit = async (data) => {
  const res = await createAxios.post("/contact", data);
  console.log("contact submit", res);
  return res.data;
};

export const paymentSubmit = async (data) => {
  const res = await createAxios.post("/payment", data);
  console.log("payment submit", data, res);
  return res.data;
};

export async function dashboardLogin(payload) {
  try {
    const formData = new URLSearchParams();
    formData.append("username", payload.username);
    formData.append("password", payload.password);

    const res = await createAxios.post("/token", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    // Store token in cookies with timestamp
    if (res.data.access_token) {
      document.cookie = `access_token=${res.data.access_token}; path=/; secure; samesite=strict`;
      localStorage.setItem("access_token_timestamp", Date.now().toString());
    }

    return res.data;
  } catch (err) {
    console.error("dashboardLogin error:", {
      status: err?.response?.status,
      errorData: err?.response?.data,
      message: err?.message,
    });
    throw err;
  }
}